import React from "react";
import {
  GridToolbarContainer,
  GridToolbarColumnsButton,
  GridToolbarFilterButton,
  GridToolbarExport,
  GridToolbarDensitySelector,
} from "@mui/x-data-grid";
import Button from "@mui/material/Button";
import DownloadForOfflineOutlinedIcon from "@mui/icons-material/DownloadForOfflineOutlined";
import { CSVLink } from "react-csv";

// Custom Pagination for DataGrid Table
export const DatGridCustomToolbar = (props) => {
  const {
    onExportAllClick,
    exportedClaimsData,
    exportedLoading,
    csvLinkEl,
    headers,
    serverMode,
    fileName,
    // eslint-disable-next-line no-unsafe-optional-chaining
  } = props?.myCustomProp;

  return (
    <div style={{ margin: "0 auto" }}>
      <GridToolbarContainer>
        <GridToolbarColumnsButton />
        <GridToolbarFilterButton />
        <GridToolbarDensitySelector />
        <GridToolbarExport />
        {serverMode && (
          <>
            <Button
              startIcon={<DownloadForOfflineOutlinedIcon />}
              onClick={onExportAllClick}
              size="small"
            >
              {exportedLoading ? "Exporting..." : "Export All"}
            </Button>
            {exportedClaimsData?.length ? (
              <CSVLink
                data={exportedClaimsData}
                filename={fileName}
                headers={headers}
                ref={csvLinkEl}
              />
            ) : null}{" "}
          </>
        )}
      </GridToolbarContainer>
    </div>
  );
};
